<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>افزودن درگاه</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.name.val" :description="form.name.inv" label="نام" />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.gateway_type.val"
                                        :description="form.gateway_type.inv"
                                        label="نوع درگاه"
                                        :options="[
                                            {value: '1', label:'گروه آینده مجازی امن'},
                                            {value: '2', label: 'آتیه داده پرداز - دیتابیس'},
                                            {value: '3', label:'رهیاب رایانه گستر'},
                                            {value: '4', label:'مرکز گسترش فناوری اطلاعات'},
                                            {value: '5', label:'ارمغان راه طلایی'},
                                            {value: '6', label:'پیام افزار پیک آسا (021)'},
                                            {value: '7', label:'فرهنگ و توسعه کندو'},
                                            {value: '8', label:'رهیاب پیام گستران'},
                                            {value: '9', label:'پیام افزار پیک آسا (9000)'},
                                            {value: '10', label:'راهکار سرزمین هوشمند'},
                                            {value: '11', label:'بیتل'},
                                            {value: '12', label:'12'},
                                            {value: '13', label:'13'},
                                            {value: '14', label:'14'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.gateway_type.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.gateway_username.val" :description="form.gateway_username.inv" dir="ltr" label="نام کاربری" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.gateway_password.val" :description="form.gateway_password.inv" dir="ltr" type="password" label="رمز عبور" />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.first_page_fa.val" :description="form.first_page_fa.inv" label="صفحه اول فارسی" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.second_page_fa.val" :description="form.second_page_fa.inv" label="صفحه دوم فارسی" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.first_page_en.val" :description="form.first_page_en.inv" label="صفحه اول انگلیسی" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.second_page_en.val" :description="form.second_page_en.inv" label="صفحه دوم انگلیسی" />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_active.val"
                                        :description="form.is_active.inv"
                                        label="وضعیت"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.is_active.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.company_name.val" :description="form.company_name.inv" label="نام شرکت" />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> افزودن</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import validator from '../mixins'
export default {
    mixins: { validator },
    data() {
        return {
            form: {
				name: {val: '', inv: '', v: { req: true, max: 256}},
                gateway_username: {val: '', inv: '', v: { max: 64}},
                gateway_password: {val: '', inv: '', v: { max: 64}},
                gateway_type: {val: '', inv: '', v: { req: true, max: 8}},
                is_active: {val: '', inv: '', v: { req: true, max: 8}},
                first_page_fa: {val: '', inv: '', v: { req: true, max: 64}},
                second_page_fa: {val: '', inv: '', v: { req: true, max: 64}},
                first_page_en: {val: '', inv: '', v: { req: true, max: 64}},
                second_page_en: {val: '', inv: '', v: { req: true, max: 64}},
                company_name: {val: '', inv: '', v: { max: 246}},

			},
            disable: false,
        }
    },
    methods: {
        submit(){
            if(this.disable == false){
                const data = new FormData();
                for (const key in this.form){
                    data.set(key, this.form[key].val);
                }
                this.axios.post('sms_gateways/', data)
                    .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'افزودن با موفقیت انجام شد.'
                        });
                        for (const key in this.form){
                            this.form[key].val = '';
                        }
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        }
    },
	beforeCreate(){
        if(this.$store.state.perms.can_add_sms_gateway == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
